// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Kh-z","articleImagesWrap":"Lh-z","articleImage":"Mh-z","singleImage":"Nh-z"};